import { components } from '@/utils'

import svgIcon from '@/components/icon/svg'
import preloader from '@/components/preloader'

const className = 'button'

function renderIconContent(h, icon) {
  if (icon) {
    let iconComponent = components.icon
    if (this.iconSVG) {
      iconComponent = svgIcon
    }

    return h(
      iconComponent,
      {
        props: {
          value: icon,
          color: this.$_iconColor,
          size: this.$_iconSize
        }
      }
    )
  }

  return this.$slots.icon
}

function renderIconHolder(h, icon) {
  return h(
    'div',
    {
      class: {
        [`${className}__icon`]: true,
        [`${className}__icon--${this.iconColor}`]: !!this.iconColor
      }
    },
    [ renderIconContent.call(this, h, icon) ]
  )
}
function renderIcon(h, icon) {
  if (icon) {
    return renderIconHolder.call(this, h, icon)
  }
}
function renderLabel(h) {
  if (this.$_label) {
    return h(
      'div',
      {
        class: `${className}__label`
      },
      [ this.$_label ]
    )
  }
}
function renderPreLoaderContent(h) {
  return h(
    preloader,
    {
      props: {
        size: this.$_iconSize / 2,
        color: this.preloaderColor,
        count: this.preloaderCount
      }
    }
  )
}
function renderPreLoader(h) {
  if (this.loading) {
    return h(
      'div',
      {
        class: `${className}__loading`
      },
      [ renderPreLoaderContent.call(this, h) ]
    )
  }
}
function renderHolder(h) {
  return h(
    'div',
    {
      class: `${className}__holder`
    },
    [
      renderIcon.call(this, h, this.$_icon),
      renderLabel.call(this, h),
      renderIcon.call(this, h, this.suffix),
      renderPreLoader.call(this, h)
    ]
  )
}

function renderDialogSlot() {
  if (typeof this.$scopedSlots.dialog === 'function') {
    return this.$scopedSlots.dialog()
  }

  return this.$slots.dialog
}

function renderContent(h) {
  return [
    renderHolder.call(this, h),
    renderDialogSlot.call(this, h)
  ]
}

function renderLink(h) {
  return h(
    'router-link',
    {
      props: {
        to: this.to,
        custom: true
      },
      scopedSlots: {
        default: ({ href, navigate }) => {
          return h(
            'a',
            {
              attrs: this.getLinkAttributes(href),
              class: this.$_class,
              directives: this.$_directives,
              on: this.getLinkHandlers(navigate)
            },
            renderContent.call(this, h)
          )
        }
      }
    }
  )
}

export default function(h) {
  if (this.isLink) {
    return renderLink.call(this, h)
  }

  return h(
    'button',
    {
      attrs: this.$_attrs,
      class: this.$_class,
      directives: this.$_directives,
      on: this.$eventHandlers
    },
    renderContent.call(this, h)
  )
}
